import React from 'react'
import ReactDOM from 'react-dom/client'
import TagManager from 'react-gtm-module'
import { BrowserRouter } from 'react-router-dom'

import { Providers } from './Providers'
import { UTMProvider } from './components/UTMProvider'
import { AuthProvider } from './context/AuthContext'
import { SupportProvider } from './Providers/SupportProvider'
import { router } from './router'
import './styles/globals.scss'

// Initialize dataLayer before GTM
declare global {
    interface Window {
        dataLayer: any[]
    }
}

// Ensure dataLayer exists
window.dataLayer = window.dataLayer || []

// Initialize Google Tag Manager
const tagManagerArgs = {
    gtmId: 'GTM-MRN8943M',
    dataLayer: window.dataLayer
}

try {
    TagManager.initialize(tagManagerArgs)
    console.log('GTM initialized successfully', window.dataLayer)
} catch (error) {
    console.error('GTM initialization failed:', error)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <UTMProvider>
                <Providers>
                    <AuthProvider>
                        <SupportProvider>{router}</SupportProvider>
                    </AuthProvider>
                </Providers>
            </UTMProvider>
        </BrowserRouter>
    </React.StrictMode>
)
